import React, { Component } from 'react'

import { getPlaybookByID } from 'api/playbooks'
import PlaybookCategoryHeader from 'components/PlaybookCategoryHeader'
import getDateRanges from 'components/PlaybookCategoryHeader/DateTimeBuilder'

import SignatureReports from './SignatureReports'
import EmailReports from './EmailReports'
import { Div } from '@driftt/tide-core'

import './styles.css'

class PlaybookReport extends Component {
  constructor(props) {
    super(props)

    const dates = getDateRanges('last_30_days')

    this.state = {
      dateRanges: dates,
      playbook: null,
      playbookLoaded: false,
    }
  }

  componentDidMount() {
    this.getPlaybook()
  }

  getPlaybook = async () => {
    const { id } = this.props.match.params
    this.setState({ playbookLoaded: false })
    try {
      const { data } = await getPlaybookByID(id)
      this.setState({ playbook: data, playbookLoaded: true })
    } catch (error) {
      console.warn(error)
    }
  }

  setDateRanges = (ranges) => {
    const { current, previous } = ranges
    this.setState({
      currentDateRange: current,
      previousDateRange: previous,
      dateRanges: ranges
    })
  }

  choosePlaybookPage = () => {
    const { playbook, dateRanges } = this.state
    if (!playbook) {
      return null
    }

    const reportProps = {
      playbook,
      currentDateRange: dateRanges.current,
      previousDateRange: dateRanges.previous,
    }

    if (playbook.reportType === 'SIGNATURE') {
      return <SignatureReports {...reportProps} />
    } else {
      return <EmailReports {...reportProps} />
    }
  }

  render() {
    const { playbook } = this.state

    const reportPage = this.choosePlaybookPage()

    return (
      <Div className="reports-container">
        <Div className="playbook-report-constrain-width">
          <PlaybookCategoryHeader changeDates={this.setDateRanges} playbook={playbook}/>
          {reportPage}
        </Div>
      </Div>
    )
  }
}

export default PlaybookReport
